import { useState, useEffect } from "react";
import { Grid, FormControlLabel, Switch, Backdrop, CircularProgress, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, InputLabel, OutlinedInput, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";

import axios from "../api/axios"

export default function OficialesFindLista(props) {
    const [openDialog, setOpenDialog] = useState(false)
    const [buscar, setBuscar] = useState("")
    const [inactivo, setInactivo] = useState(false)
    const [rows, setRows] = useState([]);
    const [seleccion, setSeleccion] = useState(0)
    const [procesando, setProcesando] = useState(false)

    useEffect(() => {
        actRows();
    }, [])

    useEffect(() => {
        setOpenDialog(props.open)
    }, [props.open]);

    useEffect(() => {
        actRows();
    }, [buscar, inactivo])

    const actRows = async () => {
        setProcesando(true)
        let mRows = []
        try {
            const respuesta = await axios.post("oficiales/buscar", {
                buscar: buscar,
                inactivos: (inactivo ? -1 : 0)
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data.lista;
            console.log(data)
            data.map((item) => {
                let mId = item.id;
                let mNombre = item.nombre;
                let mEstatus = item.estatus;
                mRows.push({
                    id: mId,
                    nombre: mNombre,
                    estatus: mEstatus
                })
            })
        } catch (error) {
            console.log(error)
        }
        setRows(mRows)
        setProcesando(false)
    }

    const handleSeleccion = (cual) => {
        setSeleccion(cual)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }


    return (
        <Dialog maxWidth={"400px"} open={openDialog} fullWidth >
            {objWait()}
            <DialogTitle>Búsqueda de Oficiales</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={8}>
                        <InputLabel htmlFor="buscar">Buscar...</InputLabel>
                        <OutlinedInput
                            id="buscar"
                            type="text"
                            value={buscar}
                            onChange={(event) => { setBuscar(event.target.value.toUpperCase()) }}
                            name="buscar"
                            autoComplete="off"
                            placeholder="Digite el nombre a buscar"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={3} >
                        <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                            <FormControlLabel control={<Switch checked={inactivo} onChange={(event) => setInactivo(event.target.checked)} />} label="Incluir inactivos" />
                        </Box>

                    </Grid>
                </Grid>
                <TableContainer component={Paper} sx={{ height: "400px" }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nombre</TableCell>
                                <TableCell>Estatus</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((item, index) => (
                                <TableRow key={item.id} hover onClick={() => { handleSeleccion(item.id) }} selected={item.id == seleccion} onDoubleClick={() => props.seleccion(item.id)} >
                                    <TableCell>{item.nombre}</TableCell>
                                    <TableCell>{item.estatus}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { props.cerrar() }}>Cancelar</Button>
                <Button onClick={() => { props.seleccion(seleccion) }}>Seleccionar</Button>
            </DialogActions>
        </Dialog>
    )
}